import { ButtonDiscuss } from "@/components/ButtonDiscuss";
import { navLinks } from "@/lib/nav-links";
import Link from "next/link";

type Props = {
  classes: {
    nav: string;
    navLinks: string;
    navLink: string;
  };
  onClick?: () => void;
  showButton?: boolean;
};

export const Nav = ({ classes, onClick, showButton = true }: Props) => {
  return (
    <nav className={classes.nav}>
      <ul className={classes.navLinks}>
        {navLinks.map((link) => {
          return (
            <li key={link.id}>
              <Link
                onClick={onClick}
                className={classes.navLink}
                href={link.href}
                scroll={true}
              >
                {link.name}
              </Link>
            </li>
          );
        })}
      </ul>
      {showButton && <ButtonDiscuss text={"Обсудить проект"} />}
    </nav>
  );
};
